import React from 'react';

const JobProgress = ({ item, loading = false }) => (
    <span className="bsi-mono" title={item.job_id ? `MediaConvert job ${item.job_id}${item.job_status ? ` · ${item.job_status}` : ''}` : undefined}>
        {loading ? 'Updating…' : item.job_status === 'CANCELLED' || item.status === 'CANCELLED'
            ? 'Cancelled' : Number.isFinite(item.job_percent_complete)
            ? `${item.job_percent_complete}%` : item.job_id ? 'Not available' : '—'}
    </span>
);

export default JobProgress;
